// extracted by mini-css-extract-plugin
export default {"addressSection":"B1-z","disabled":"C1-z","sectionButtons":"D1-z","logo":"E1-z"};